import { useEffect, useRef, useState } from "react";

const POLL_INTERVAL = 5 * 60 * 1000; // 5 minutes

export function useAppVersion() {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const currentBuildTime = useRef(null);

    useEffect(() => {
        const checkVersion = async () => {
            try {
                const res = await fetch(`/meta.json?t=${Date.now()}`);
                if (!res.ok) return;
                const data = await res.json();
                if (currentBuildTime.current === null) {
                    currentBuildTime.current = data.buildTime;
                } else if (data.buildTime !== currentBuildTime.current) {
                    setUpdateAvailable(true);
                }
            } catch (_) {}
        };

        checkVersion();
        const timer = setInterval(checkVersion, POLL_INTERVAL);
        return () => clearInterval(timer);
    }, []);

    return updateAvailable;
}
